import { PostHogProvider } from '@posthog/react';
import Highcharts from 'highcharts';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'mobx-react/batchingForReactDom'; // https://github.com/mobxjs/mobx-react-lite/#observer-batching
import moment from 'moment';
import * as mTZ from 'moment-timezone';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './custom-bootstrap.scss';
import * as serviceWorker from './serviceWorker';
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/pattern-fill')(Highcharts);

// Highcharts timezone fix
// https://github.com/highcharts/highcharts/issues/8661
window.moment = moment;
mTZ();

// Fixes mapbox issue in production build https://github.com/mapbox/mapbox-gl-js/issues/10173
mapboxgl.workerClass =
  // eslint-disable-next-line import/no-webpack-loader-syntax
  require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const postHogOptions = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30'
};

ReactDOM.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={postHogOptions}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

